import 'moment/locale/es';
import * as React from 'react';
import * as Firebase from 'firebase';
import moment from 'moment';
import { Provider as StateProvider } from 'unstated';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';

import red from '@material-ui/core/colors/red';
import CssBaseline from '@material-ui/core/CssBaseline';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import ApolloClient from 'apollo-boost';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

// import DrawerWidget from './containers/DrawerWidget';
import SideMenu from './containers/SideMenu';
import NewFarmFlow from './containers/NewFarmFlow';
import ChooseScenes from './containers/ChooseScenes';
import DefineFieldsFlow from './containers/DefineFieldsFlow';
import RootExplore from './containers/RootExplore';
import FarmExplore from './containers/FarmExplore';
import YieldAnalysis from './containers/YieldAnalysis';
import BetaDialog from './containers/BetaDialog';
import AcceptInvite from './containers/AcceptInvite';
import Library from './containers/Library';
import FarmConfig from './containers/FarmConfig';
import AutoTracking from './containers/AutoTracking';
import Notifications from './containers/Notifications';
import Authentication from './containers/Authentication';
import Account from './containers/Account';
import Reports from './containers/Reports';
import ReportsCreation from './containers/ReportsCreation';
import Administrator from './containers/Administrator';
import ZoneAnalysis from './containers/ZoneAnalysis';
import Prescription from './containers/Prescription';

import { LayoutToolsProvider, FirebaseAuthProvider } from './providers';

moment.locale('es');

// A theme with custom primary and secondary color.
// It's optional.
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#04DA83',
      contrastText: '#FFF'
    },
    secondary: red
  }
});

const styles: StyleRulesCallback = t => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  content: {
    flexGrow: 1,
    backgroundColor: t.palette.background.default,
    minWidth: 0 // So the Typography noWrap works
  }
});

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URL
});

Firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
});

class App extends React.Component<WithStyles> {
  state = {
    dialog: null
  };

  renderAuthenticated() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <SideMenu />
        <main className={classes.content}>
          <Switch>
            <Route path="/" exact={true} component={RootExplore} />
            <Route path="/explore" component={RootExplore} />
            <Route path="/newfarm" component={NewFarmFlow} />
            <Route path="/newfield/:farmId" component={DefineFieldsFlow} />
            <Route path="/yield/:fieldId" component={YieldAnalysis} />
            <Route path="/zones/:fieldId" component={ZoneAnalysis} />
            <Route path="/prescription/:fieldId" component={Prescription} />
            <Route path="/tracking/:fieldId" component={AutoTracking} />
            <Route path="/farms/:farmId" component={FarmExplore} />
            <Route path="/scenes/:farmId" component={ChooseScenes} />
            <Route path="/library/:farmId" component={Library} />
            <Route path="/config/:farmId" component={FarmConfig} />
            <Route path="/reports/:farmId/list" component={Reports} />
            <Route path="/reports/:farmId/create/:type" component={ReportsCreation} />
            <Route path="/notifications" component={Notifications} />
            <Route path="/accept-invitation/:token" component={AcceptInvite} />
            <Route path="/login" children={<Authentication mode="login" />} />
            <Route path="/signup" children={<Authentication mode="signup" />} />
            <Route path="/account" component={Account} />
            <Route path="/admin" component={Administrator} />
          </Switch>
        </main>
      </div>
    );
  }

  renderUnAuthenticated() {
    return (
      <Switch>
        <Route exact={true} path="/" component={Authentication} />
        <Route path="/login" children={<Authentication mode="login" />} />
        <Route path="/signup" children={<Authentication mode="signup" />} />
      </Switch>
    );
  }

  render() {
    return (
      <StateProvider>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <MuiThemeProvider theme={theme}>
              <MuiPickersUtilsProvider
                
                utils={MomentUtils}
                moment={moment}
                locale="es"
              >
                <CssBaseline />
                <LayoutToolsProvider>
                  {layout => (
                    <>
                      <BetaDialog
                        open={layout.state.dialog === 'beta'}
                        onClose={() => layout.closeAnyDialog()}
                      />
                    </>
                  )}
                </LayoutToolsProvider>
                <FirebaseAuthProvider>
                  {user =>
                    user
                      ? this.renderAuthenticated()
                      : this.renderUnAuthenticated()
                  }
                </FirebaseAuthProvider>
              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
          </BrowserRouter>
        </ApolloProvider>
      </StateProvider>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.tsx